import React, { Component } from 'react';
import { Dimensions, Image, StyleSheet, Text, View, TouchableOpacity, Animated, Linking, I18nManager as RNI18nManager, AsyncStorage } from 'react-native';
import { color } from '../config/color';
import { withNavigation } from 'react-navigation';
import { FlatList } from "react-native-gesture-handler";
import i18n from 'i18n-js';

class SLinksDialog extends Component {

    state = {
        links: [],
        isShowing: false,
        opacity: new Animated.Value(0)
    }

    componentDidUpdate(props) {
        var height = 0;
        var width = 0;
        if (props.showFullMode) {
            height = props.height * 0.8
            width = 520
        } else {
            height = props.height
            width = props.width
        }

        this.state.height = height;
        this.state.width = width;
        this.state.showFullMode = props.showFullMode
    }

    constructor(props) {
        super(props);

        this.state.handleClose = props.handleClose;

        this.state.links = [];
        props.links.forEach(link => {
            if (link.status) {
                this.state.links.push(link);
            }
        })

        this.state.linksTitle = props.linksTitle;
        this.state.linksLogoUrl = props.linksLogoUrl;

        this.state.showFullMode = props.showFullMode;

        if (this.state.showFullMode) {
            this.state.height = props.height * 0.7
            this.state.width = 520
        } else {
            this.state.height = props.height
            this.state.width = props.width
        }
    }

    renderLinkItem = ({ item, index }) => {
        return (

            <View style={{ width: '100%', marginTop: 10, borderRadius: 19, backgroundColor: '#F0F0F0' }}>

                <TouchableOpacity style={{
                        height: 60, 
                        display: 'flex', flexDirection: 'row',
                        alignItems: "center"
                    }}
                    onPress={() => {
                        AsyncStorage.setItem("linksPopupShowed", true).then((value) => {});
                        window.location.replace(item.url);
                    }}
                >

                    <Image source={item.icon} style={{ marginLeft: 10, width: 50, height: 50, overflow: "hidden", borderRadius: 25 }}></Image>
                    
                    <Text style={{
                            fontFamily: 'main-regular', color: 'black',
                            fontSize: 14, textAlign: 'left',
                            marginRight: 10, marginLeft: 10
                        }}>{item.title}
                     </Text>

                </TouchableOpacity>

            </View>
        )
    }

    render() {

        return (

            <View style={styles.container}>

                <View style={styles.bgContainer} />

                <View style={styles.container}>

                    <View style={{
                        borderRadius: this.state.showFullMode ? 53 : 0, alignContent: "center", alignItems: "center", justifyContent: "center",
                        position: 'absolute', backgroundColor: 'white', width: this.state.width, height: this.state.height,
                    }}>
                        
                        <Image source={this.state.linksLogoUrl} style={{ width: 120, height: 120, overflow: "hidden", borderRadius: 60, marginTop: this.state.height * 0.15 }}></Image>
                        <Text style={{
                            fontFamily: 'main-regular', color: 'black', marginTop: 10,
                            fontSize: 16, textAlign: 'center',
                            marginRight: 10, marginLeft: 10
                        }}>{this.state.linksTitle}
                        </Text>

                        <FlatList
                            style={{ direction: RNI18nManager.isRTL ? 'rtl' : 'ltr', width: '80%', marginTop: this.state.height * 0.05 }}
                             extraData={this.state}
                            data={this.state.links}
                            renderItem={this.renderLinkItem}
                            keyExtractor={item => item.url}
                        />

                        <TouchableOpacity style={{
                                height: 40, 
                                marginBottom: 10,
                                alignItems: "center", justifyContent: "center"
                            }}
                            onPress={() => {
                                this.state.handleClose();
                            }}
                        >                            
                            <Text style={{
                                    textDecorationLine: 'underline',
                                    fontFamily: 'main-regular', color: 'black',
                                    fontSize: 14, 
                                }}>{i18n.t('close').toUpperCase()}</Text>

                        </TouchableOpacity>

                    </View>

                </View>



            </View>

        );
    }
}

export default withNavigation(SLinksDialog);

const styles = StyleSheet.create({
    container: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        display: 'flex',
        position: 'absolute',
        width: '100%',
        height: '100%',
    },
    bgContainer: {
        opacity: 0.4,
        backgroundColor: 'black',
        width: '100%',
        height: '100%',
    },
    imgGroup: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 30,
        flexWrap: 'wrap'
    },
    poweredby: {
        alignItems: 'center',
        position: 'absolute',
        bottom: 50,
        width: '100%',
    },
    button: {
        marginLeft: 55,
        marginRight: 25,
        height: 60,
        borderBottomWidth: 1,
        borderBottomColor: color.menuUnselected,
        justifyContent: "center"
    }
})  